import React from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../styles/notifications.css";

const ICONS = {
  success: "bi bi-check-lg",
  warning: "bi bi-exclamation-triangle",
  danger: "bi bi-x-lg",
  info: "bi bi-info-circle",
};

const TITLES = {
  success: "Operación exitosa",
  warning: "Atención",
  danger: "Ocurrió un error",
  info: "Información",
};

export default function Toast({
  type = "info",
  message = "",
  onClose,
  inline = false,
  actions = null,
}) {
  const icon = ICONS[type] || ICONS.info;
  const title = TITLES[type] || TITLES.info;
  const className = `toast-card ${type} ${inline ? "inline" : ""}`;

  return (
    <div className={className} role="alert">
      <div className="toast-icon">
        <i className={icon}></i>
      </div>
      <div className="toast-content">
        <div className="toast-title">{title}</div>
        <p className="toast-message mb-0">{message}</p>
      </div>
      {actions && <div className="toast-actions">{actions}</div>}
      {onClose && (
        <button type="button" className="toast-close" onClick={onClose}>
          <i className="bi bi-x"></i>
        </button>
      )}
    </div>
  );
}
